import { TextAlignment, TextVerticalAlignment } from "building-types/annotation/annotationTypesEnum";
import { ZERO_PIXELS } from "common/constants/scaleFactors";
import type { FontId } from "common/constants/textFont";
import type { SheetPixels } from "common/types/nominalNumbersTypes";
import { DIST_EPSILON } from "geom/core";
import type { Mat3 } from "geom/mat3";
import { mat3Reduce } from "geom/mat3";
import {
  mat3ToCSSMatrix,
  textHorizontalAlignmentToTextAnchor,
  textVerticalAlignmentToDominantBaseline,
} from "lib/house/svg/svgUtils";
import { jsxToString } from "./conversion";

interface PlanLabelProps {
  text: string;
  fontSize: SheetPixels;
  fontFamily: FontId;
  transform?: Mat3[];
  fill?: string;
  stroke?: string;
  strokeWidth?: SheetPixels;
  alignment?: TextAlignment;
  verticalAlignment?: TextVerticalAlignment;
}

export function generatePlanLabel(props: PlanLabelProps, wrapSvg = false): string {
  return jsxToString(<PlanLabel {...props} />, wrapSvg);
}

const PlanLabel = ({
  text,
  fontSize,
  fontFamily,
  transform = [],
  fill = "black",
  stroke = "white",
  strokeWidth = ZERO_PIXELS,
  alignment = TextAlignment.LEFT,
  verticalAlignment = TextVerticalAlignment.BOTTOM,
}: PlanLabelProps) => {
  const finalTransform = mat3Reduce(transform);
  const cssMatrix = mat3ToCSSMatrix(finalTransform);

  const textAnchor = textHorizontalAlignmentToTextAnchor(alignment);
  const dominantBaseline = textVerticalAlignmentToDominantBaseline(verticalAlignment);

  return (
    <g>
      {strokeWidth > DIST_EPSILON && (
        <text
          transform={`matrix(${cssMatrix})`}
          fill={stroke}
          stroke={stroke}
          strokeWidth={strokeWidth}
          fontSize={fontSize}
          fontFamily={fontFamily}
          textAnchor={textAnchor}
          dominantBaseline={dominantBaseline}
        >
          {text}
        </text>
      )}
      <text
        transform={`matrix(${cssMatrix})`}
        fill={fill}
        fontSize={fontSize}
        fontFamily={fontFamily}
        textAnchor={textAnchor}
        dominantBaseline={dominantBaseline}
      >
        {text}
      </text>
    </g>
  );
};

export default PlanLabel;
